<template>
    <div>
        <el-tabs v-model="type" @tab-click="tabChange">
            <el-tab-pane label="充提记录" name="txr"/>
            <el-tab-pane label="站内转账记录" name="itxr"/>
        </el-tabs>

        <el-card v-show="type === 'txr'">
            <el-select v-model="txStatus" multiple filterable size="mini" class="search" placeholder="状态"
                       style="width: 100%">
                <el-option :key="'all'" :value="'all'" :label="'全部状态'">全部状态</el-option>
                <el-option v-for="item in statusList" :key="item.value" :value="item.value" :label="item.label">
                    {{item.label}}
                </el-option>
            </el-select>
            <el-autocomplete placeholder="输入币种"  size="mini" v-model="coinType" :fetch-suggestions="queryCoinType"/>
<!--            <el-input v-model="coinType" size="mini" class="search" placeholder="输入币种"/>-->
            <el-input v-model="userId" size="mini" class="search" placeholder="输入用户ID" clearable/>
            <el-select v-model="txType" filterable size="mini" class="search" placeholder="类型">
                <el-option :key="0" :value="0" label="全部">全部</el-option>
                <el-option :key="1" :value="1" label="充值">充值</el-option>
                <el-option :key="-1" :value="-1" label="提现">提现</el-option>
            </el-select>
            <el-date-picker v-model="time" type="datetimerange" range-separator="至" start-placeholder="开始日期"
                            end-placeholder="结束日期" value-format="timestamp" size="mini" clearable/>
            <el-button type="primary" icon="el-icon-search" @click="queryTxRecord(true)"  size="mini" style="margin-left: 20px">查询</el-button>
            <el-button type="primary" @click="exportTxRecord()" size="mini">导出数据</el-button>
            <el-checkbox v-model="needUserName" style="margin-left: 30px">是否导出用户信息</el-checkbox>
            <el-table v-if="tableAble" :data="txRecord">
                <el-table-column label="币种" prop="coinType"></el-table-column>
                <el-table-column label="用户ID" prop="userId"></el-table-column>
                <el-table-column label="类型">
                    <template slot-scope="scope">
                        {{ scope.row.txType == 1 ? "充值" : "提现" }}
                    </template>
                </el-table-column>
                <el-table-column label="数额" prop="txAmount"/>
                <el-table-column label="hash" prop="txNetworkId"/>
                <el-table-column label="转入地址" prop="txFromWallet"/>
                <el-table-column label="转出地址" prop="txToAddress"/>
                <el-table-column label="状态">
                    <template slot-scope="scope">
                        {{ STATUS['s' + scope.row.txStatus] }}
                    </template>
                </el-table-column>
                <el-table-column label="时间">
                    <template slot-scope="scope">
                        {{ scope.row.createdTime | moment }}
                    </template>
                </el-table-column>
            </el-table>
            <div class="pager-wrap">
                <pagination :size="size" :page="page" :total="txRecordTotal" @pageChanged="handlePageChanged"/>
            </div>
        </el-card>

        <el-card v-show="type === 'itxr'">
            <el-select v-model="activeStatus" size="mini" class="search" placeholder="状态">
                <el-option v-for="item in statusItxList" :key="item.value" :value="item.value" :label="item.label">
                    {{item.label}}
                </el-option>
            </el-select>
          <el-autocomplete placeholder="输入币种"  size="mini" v-model="queryParams.coinType" :fetch-suggestions="queryCoinType"/>
<!--            <el-input v-model="queryParams.coinType" size="mini" class="search" placeholder="输入币种"/>-->
            <el-date-picker v-model="dateArr" type="datetimerange" range-separator="至" size="mini"
                            start-placeholder="下单开始时间"
                            end-placeholder="下单结束时间" value-format="timestamp"></el-date-picker>
            <el-select v-model="queryParams.type" size="mini" placeholder="请选择">
                <el-option v-for="item in typeList" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
            </el-select>
            <el-input placeholder="请输入内容" size="mini" clearable v-model="queryParams.typeValue" style="width: 350px">
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
            <el-button type="primary" icon="el-icon-search" @click="queryItxRecord()"  size="mini">
              查询
           </el-button>
          <el-button type="" icon="" @click="queryItxRecord(true)"  size="mini">
            重置
          </el-button>
            <el-table v-if="tableAble" :data="iTxRecord">
                <el-table-column prop="fromUser" label="下单用户ID" ></el-table-column>
                <el-table-column prop="fromUserName" label="下单用户" ></el-table-column>
                <el-table-column prop="toUser" label="提现账户ID" ></el-table-column>
                <el-table-column label="提现账户" width="200">
                    <template slot-scope="scope">
                        <span>{{scope.row.toUserTel?scope.row.toUserTel:scope.row.toUserEmail}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="txCoin" label="币种"></el-table-column>
                <el-table-column prop="txAmount" label="提币数量"></el-table-column>
                <el-table-column prop="txFee" label="手续费"></el-table-column>
                <el-table-column prop="txStatusDesc" label="订单状态"></el-table-column>
                <el-table-column min-width="60" label="申请时间">
                    <template slot-scope="scope">
                        {{scope.row.createTime | moment}}
                    </template>
                </el-table-column>
                <el-table-column min-width="60" label="审核时间">
                    <template slot-scope="scope">
                        {{scope.row.checkTime | moment}}
                    </template>
                </el-table-column>
                <el-table-column min-width="60" label="提币时间">
                    <template slot-scope="scope">
                        {{scope.row.transferTime | moment}}
                    </template>
                </el-table-column>
            </el-table>
            <div class="pager-wrap">
                <el-pagination style="margin-top: 30px"
                               @size-change="handleSizeChange"
                               @current-change="handleCurrentChange"
                               :current-page="queryParams.page"
                               :page-sizes="[10, 20, 50, 100, 500, 1000, 2000, 5000]"
                               :page-size="queryParams.size"
                               layout="total, sizes, prev, pager, next, jumper"
                               :total="iTxRecordTotal">
                </el-pagination>
            </div>
        </el-card>
    </div>
</template>
<script>
    import "../store.js";
    import {mapState, mapActions} from "vuex";
    import Pagination from "components/pagination";
    import {TX_STATUS, STATUSLIST} from '../constants.js';
    import {formatTable} from "../../../common/tools.js";
    import api from '../api';

    export default {
        name: "dataCenterDw",
        data() {
            return {
                coinTypeList:[],
                type: undefined === this.$route.query.type || (this.$route.query.type).length<1? "txr":(this.$route.query.type),
                dateVal: "",
                coinType: (this.$route.query.coinType===undefined || this.$route.query.coinType.length<1)  && this.type!=="txr"? "": this.$route.query.coinType,
                txType: (this.$route.query.txtype===undefined) ? 0: parseInt(this.$route.query.txtype),
                userId: (this.$route.query.uid===undefined || this.$route.query.uid.length<1)  && this.type!=="txr"? "": this.$route.query.uid,
                txStatus: "all",
                needUserName: false,
                time: "",
                STATUS: TX_STATUS,
                statusItxList: STATUSLIST,
                page: 1,
                size: 10,
                statistic: {
                    coinType: 'BTC',
                    size: '50',
                    txType: 1,
                },
                txTypes: [{code: 1, desc: '充值'}, {code: -1, desc: '提现'}, {code: -2, desc: '内部转账'}],
                queryParams: {
                    type: "1",
                    typeValue: (this.$route.query.uid==undefined || this.$route.query.uid.length<1) && this.$route.query.type!=="itxr"? "": this.$route.query.uid,
                    startTime: "",
                    endTime: "",
                    coinType: (this.$route.query.coinType==undefined || this.$route.query.coinType.length<1) && this.$route.query.type!=="itxr"? "": this.$route.query.coinType,
                    username: "",
                    userId: (this.$route.query.uid==undefined || this.$route.query.uid.length<1) && this.$route.query.type!=="itxr"? "": this.$route.query.uid,
                    status: "",
                    showTag: false,
                    page: 1,
                    size: 10,
                },
                dateArr: [],
                activeStatus: "ALL",
                typeList: [
                    {label: '手机或邮箱', value: "0"},
                    {label: '用户ID', value: "1"},
                ],
            };
        },
        methods: {
            ...mapActions("dataCenter", [
                "getDepositWithdrawByTime",
                "getWithdrawFreeze",
                "getTxRecord",
                "getTxStatistics",
                "getItxRecord"
            ]),
            tabChange() {
                if (this.type === "dw") {
                } else if (this.type === "wfr") {
                } else if (this.type === 'txr') {
                    this.queryTxRecord();
                } else if (this.type === 'txs') {
                    this.getTxStatistics(this.statistic);
                } else if (this.type === 'itxr') {
                    this.getItxRecord(this.queryParams);
                }
            },
            queryItxRecord(clear) {
              if (clear===true){
                this.activeStatus="ALL";
                this.queryParams.coinType="";
                this.dateArr=null;
                this.queryParams.type="1";
                this.queryParams.username="";
                this.queryParams.userId="";
                this.queryParams.typeValue="";
              }
                this.queryParams.status = this.activeStatus == "ALL" ? "" : this.activeStatus;
                this.queryParams.startTime = this.dateArr ? this.dateArr[0] : null;
                this.queryParams.endTime = this.dateArr ? this.dateArr[1] : null;
                if (this.queryParams.type == "0") {
                    this.queryParams.username = this.queryParams.typeValue;
                    this.queryParams.userId = "";
                } else if (this.queryParams.type == "1") {
                    this.queryParams.userId = this.queryParams.typeValue;
                    this.queryParams.username = "";
                }
                this.getItxRecord(this.queryParams);
            },
            queryTxRecord(init) {
                let q = {};
                if (this.coinType) q.coinType = this.coinType;
                if (this.userId) q.userId = this.userId;
                if (this.txType) q.txType = this.txType;
                if (this.time) {
                    q.startTime = this.time[0];
                    q.endTime = this.time[1];
                }
                if (this.txStatus.indexOf("all") == -1) q.status = this.txStatus.join(",");
                if (init) this.page = 1;
                q.page = this.page;
                q.size = this.size;
                this.getTxRecord(q);
            },
            exportTxRecord() {
                let q = {};
                if (this.coinType) q.coinType = this.coinType;
                if (this.userId) q.userId = this.userId;
                if (this.txType) q.txType = this.txType;
                q.needUserName = this.needUserName;
                if (this.time) {
                    q.startUpdateTime = this.time[0];
                    q.endUpdateTime = this.time[1];
                }
                if (this.txStatus.indexOf("all") == -1) q.status = this.txStatus.join(",");
                api.exportTxRecord(q).then(response => {
                    const fileName = "充提记录信息表.xlsx";
                    const blob = new Blob([response], {type: 'application/vnd.ms-excel'});
                    if ('download' in document.createElement('a')) {
                        const link = document.createElement('a');
                        link.download = fileName;
                        link.style.display = 'none';
                        link.href = URL.createObjectURL(blob);
                        document.body.appendChild(link);
                        link.click();
                        URL.revokeObjectURL(link.href);
                    } else {
                        navigator.msSaveBlob(blob, fileName);
                    }
                })
            },
            handlePageChanged(pagination) {
                this.page = pagination.page;
                this.size = pagination.size;
                this.queryTxRecord();
            },
            parseDesc(code, list) {
                for (let i in list) {
                    if (code === list[i].code) {
                        return list[i].desc;
                    }
                }
            },
            handleSizeChange(val) {
                this.queryParams.size = val;
                this.getItxRecord(this.queryParams);
            },
            handleCurrentChange(val) {
                this.queryParams.page = val;
                this.getItxRecord(this.queryParams);
            },
            queryCoinType(queryString, cb) {
              let restaurants = this.coinTypeList;
              let results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
              let suggest = [];
              for (let index in results) {
                suggest.push({'value': results[index]});
              }
              cb(suggest);
            },
          createFilter(queryString) {
            return (restaurant) => {
              return (restaurant.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
            };
          }
        },
        computed: {
            ...mapState("dataCenter", ["depositWithdraw", "withdrawFreeze", "txRecord", "txRecordTotal", "iTxRecord", "iTxRecordTotal", "statisticList", "tableAble"]),
            statusList() {
                let re = [];
                for (var i = -1; i < 12; i++) {
                    re.push({
                        value: i,
                        label: this.STATUS['s' + i]
                    });
                }
                return re;
            }
        },
        watch: {
            depositWithdraw() {
                formatTable();
            },
            withdrawFreeze() {
                formatTable();
            },
            txRecord() {
                formatTable();
            },
            statisticList() {
                formatTable();
            }
        },
        mounted() {
            this.queryDepositWithdrawByTime();
        },
        components: {
            Pagination
        },
      created() {
  console.log(this.$route.query);
        // if (c_type==="2"){
        //   this.type = 'itxr';
        // }else{
        //   this.type = 'txs';
        // }
        api.getCoinTypeList().then(({ data }) => {
          this.coinTypeList=data;
          this.tabChange();
        });

      }
    };
</script>
<style scoped>
    .search {
        width: 200px;
        margin: 0px 20px 20px 0px;
    }

    .date-search {
        margin-right: 20px;
    }
</style>
